import { compose } from 'redux'
import { connect } from 'react-redux'
import { withProps, lifecycle } from 'recompose'
import withType from 'components/common/hoc/withType'
import * as actions from './actions'
import BOTGarageVehicles from './BOTGarageVehicles'
import {
  isShowVehiclePlaceholder,
  setDesktopLayoutSequence,
  setMobileLayoutSequence,
  setLaptopLayoutSequence
} from './helpers'
import { getNotificationFromLocalStorage, showNotification } from 'components/common/Notification/helpers'
import { showNewShopTiresModal } from '../../../NewShopTiresModal/actions'
import { GENERAL_SOURCE, YMME_NAME } from 'constant'

const mapDispatchToProps = {
  showNewShopTiresModal,
  ...actions
}

const mapStateToProps = state => {
  const { app: { isFetching }} = state

  return {
    isFetching
  }
}

const withInitializationAndUpdating = lifecycle({
  componentDidUpdate() {
    const { isFetching } = this.props
    if (getNotificationFromLocalStorage() && !isFetching) {
      showNotification('personalization-success')
    }
  }
})

const withMyGarageProps = withProps(({
  UserVehicleDetails: { noOfVehicles },
  showNewShopTiresModal
} = {}) => ({
  isShowVehiclePlaceholder: Boolean(isShowVehiclePlaceholder(noOfVehicles)),
  addNewVehicle: () => showNewShopTiresModal({
    isOnlyVehicle: true,
    ymmeName: YMME_NAME,
    withShowConfirmTireSizeModal: true,
    source: GENERAL_SOURCE
  })
}))

const withGridTemplateAreaLayouts = withProps(({ UserVehicleDetails: { noOfVehicles, userVehicle }} = {}) => ({
  gridTemplateAreas: {
    vehiclesGridNoVehicles: {
      desktop: setDesktopLayoutSequence(0),
      laptop: setLaptopLayoutSequence(0),
      mobile: setMobileLayoutSequence(0)
    },
    vehiclesGridWithVehicles: {
      desktop: setDesktopLayoutSequence(noOfVehicles, userVehicle),
      laptop: setLaptopLayoutSequence(noOfVehicles, userVehicle),
      mobile: setMobileLayoutSequence(noOfVehicles, userVehicle)
    }
  }
}))

export default compose(
  withType({ type: 'BOTGarageVehicles' }),
  connect(mapStateToProps, mapDispatchToProps),
  withInitializationAndUpdating,
  withMyGarageProps,
  withGridTemplateAreaLayouts
)(BOTGarageVehicles)
